import { Theme } from '@mui/material'

const classes = {
  modalPaperStyle: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceContainer,
  }),
  sectionContainer: {
    gap: 1.5,
  },
  summarySectionOuterGrid: {
    paddingY: 2.5,
    paddingX: 2,
    gap: 3,
  },
  summarySectionInnerGrid: {
    gap: 1,
    flex: 1,
  },
  summarySectionColumnGrid: {
    flexDirection: 'column',
    gap: '2px',
    flex: 1,
  },
  settingsIcon: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  sectionOuterGrid: (theme: Theme) => ({
    padding: 2,
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    borderRadius: 1.5,
    background: theme.palette.background.paper,
  }),
  statusPaused: (theme: Theme, isLargeScreen: boolean) => ({
    backgroundColor: theme.palette.ui.surfaceBright,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingX: 1,
    paddingTop: 1,
    paddingBottom: 2,
    gap: 0.5,
    marginBottom: isLargeScreen ? -2 : -1.5,
  }),
  statusPausedText: {
    textAlign: 'center',
  },
  statusItem: (theme: Theme, isLargeScreen: boolean, isWrapping: boolean) => ({
    backgroundColor: theme.palette.ui.surfaceBright,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
    borderRight: isLargeScreen && !isWrapping ? `1px solid ${theme.palette.ui.surfaceContainerHighest}` : 'none',
    paddingY: 0.5,
    minHeight: '64px',
    '&:last-child': {
      borderRight: 'none',
    },
  }),
  sectionTitle: {
    fontWeight: 600,
  },
  sectionTitleGrid: {
    flexDirection: 'column',
    gap: 0.5,
  },
  statusSectionOfflineNoticeGrid: {
    alignItems: 'center',
    gap: 1,
  },
  statusSectionOfflineNoticeIcon: (theme: Theme) => ({
    color: theme.palette.error.main,
  }),
  statusSectionOfflineNoticeText: (theme: Theme) => ({
    fontWeight: 500,
    color: theme.palette.text.secondary,
  }),
  statusSectionItemsGrid: (isLargeScreen: boolean, colCount: number, isWrapping: boolean, isOffline: boolean) => ({
    display: 'grid',
    gridTemplateColumns: isLargeScreen ? `repeat(${colCount}, 1fr)` : 'repeat(2, 1fr)',
    borderRadius: 1.5,
    gap: !isLargeScreen || isWrapping ? 0.5 : 0,
    width: '100%',
    opacity: isOffline ? 0.7 : 1,
  }),
  statusSectionLabel: {
    textTransform: 'none',
  },
  alertsListContainer: {
    flexDirection: 'column',
    rowGap: 2,
  },
  alertGroupContainer: {
    flexDirection: 'column',
    gap: 1,
  },
  alertGroupHeader: {
    display: 'flex',
    padding: 1,
    paddingTop: 2,
    alignItems: 'center',
    gap: 1,
  },
  alertGroupLabel: {
    textTransform: 'none',
  },
  urgentAlertsContainer: {
    gap: 2,
  },
  urgentAlertsBannerIcon: (theme: Theme) => ({
    color: theme.palette.error.main,
  }),
  urgentAlertsBannerText: {
    fontWeight: 600,
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginY: 3,
  },
  fullWidth: {
    width: '100%',
  },
  protectLink: {
    fontWeight: 500,
  },
  skeletonGrid: {
    gap: 1,
  },
  skeletonDateHeader: {
    marginTop: 1,
  },
  deviceType: (theme: Theme) => ({
    fontSie: '14px',
    color: theme.palette.secondary.main,
    lineHeight: '16px',
    letterSpacing: '0.25px',
  }),
  deviceLocationRow: {
    flexWrap: 'wrap',
    alignItems: 'baseline',
    columnGap: 0.5,
  },
  deviceLocation: (theme: Theme) => ({
    fontSize: '16px',
    color: theme.palette.text.primary,
    lineHeight: '20px',
    letterSpacing: '0.2px',
    fontWeight: 500,
  }),
  deviceLocationDetails: (theme: Theme) => ({
    fontSize: '16px',
    color: theme.palette.text.primary,
    lineHeight: '20px',
    letterSpacing: '0.2px',
    fontWeight: 400,
  }),
}

export default classes
